import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
// import { colors } from "../../config/config";
import { RxCross2 } from "react-icons/rx";
import axios from "axios";
import { apiKey } from "../../config/config";
import { languageHelper } from "../../config/helperFunctions";

function OurMenu({
  loader,
  handleSelect,
  catSubCat,
  handleSubCatSelect,
  clearFilters,
  filters,
  language,
}) {
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  const outlet = JSON.parse(localStorage.getItem("rms-outlet"));
  const customer = JSON.parse(localStorage.getItem("rms-customer"));

  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/customer/categories`, {
        params: {
          outletId: outlet?.outlet.id,
          customerId: customer?.id
        },
      })
      .then((res) => {
        setCategories(res.data);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [customer?.id, outlet?.outlet.id]);

  if (isLoading) {
    return (
      <div className="w-full grid place-items-center h-16">
        <img src={loader?.loader_url} className="w-16" alt="loading..." />
      </div>
    );
  }

  return (
    <section className="my-8">
      <div className="max-w-7xl w-[90%] mx-auto">
        <div className="w-full flex justify-between">
          <h3 className="font-bold text-2xl">
            {languageHelper("our menu") || "Our Menu"}
          </h3>
          {/* <button
            className={`rounded-3xl capitalize text-sm leading-6 font-medium py-1 px-3 transition text-[${colors.primary}] bg-[#FFEDF4] hover:text-white hover:bg-[${colors.primary}]`}
          >
            View All
          </button> */}
        </div>
        <div className="my-4">
          <Swiper
            slidesPerView={1}
            spaceBetween={10}
            pagination={{
              clickable: true,
            }}
            grabCursor={true}
            navigation={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Navigation, Autoplay]}
            breakpoints={{
              320: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              425: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              640: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 6,
                spaceBetween: 50,
              },
              1280: {
                slidesPerView: 7,
                spaceBetween: 50,
              },
            }}
            className="mySwiper px-16"
          >
            {categories.map((category, index) => (
              <SwiperSlide key={index} className="swiper-slide">
                <button
                  onClick={() => handleSelect(category)}
                  className="w-32 h-full flex flex-col items-center justify-center text-center p-3 c-h-30 rounded-2xl border-b-2 border-transparent transition hover:bg-[#FFEDF4] bg-[#F7F7FC]"
                >
                  <img
                    className="h-12 drop-shadow-category mx-auto"
                    src={category.cat_image_url}
                    alt=""
                  />
                  <h3 className="text-xs font-medium">
                    {defaultLang === "text_en"
                      ? category.category_name
                      : category.cat_name_arabic}
                  </h3>
                </button>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="flex gap-4 mt-4">
            {catSubCat.map((cat, i) => (
              <button
                key={i}
                onClick={() => handleSubCatSelect(cat)}
                className="w-32 h-full flex flex-col items-center justify-center text-center p-3 c-h-30 rounded-2xl border-b-2 border-transparent transition hover:bg-[#FFEDF4] bg-[#F7F7FC]"
              >
                <h3 className="text-xs font-medium">
                  {defaultLang === "text_en"
                    ? cat.sub_category_name
                    : cat.sub_category_name_arabic}
                </h3>
              </button>
            ))}
          </div>
          {filters && (
            <div className="mt-4 w-full">
              <button
                onClick={() => clearFilters()}
                className="ml-auto h-full flex gap-2 items-center justify-center text-center p-3 c-h-30 rounded-2xl border-b-2 border-transparent transition hover:bg-[#FFEDF4] bg-[#F7F7FC]"
              >
                <RxCross2 /> <span>Clear Filters</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default OurMenu;
